import styled from "@emotion/styled";
import { css } from "@emotion/react";
import colors from "../../styles/colors";
export const CardContainer = styled.div `
  font-family: Inter;
  font-weight: 400;
  background-color: white;
  font-size: 0.875rem;
  width: 100%;
  ${({ variant, padding }) => getPadding(variant, padding)}
  ${({ variant }) => getBorderRadius(variant)}
  .title-class {
    padding-bottom: 1rem;
  }
`;
export const CardBorder = styled.div `
  border: 0;
  ${({ variant, borderColor }) => variant === "bordered"
    ? `padding: 0.25rem 0 0; background-color: ${colors[borderColor]};`
    : "padding: 0; background-color: transparent"};
  ${({ variant }) => getWidth(variant)}
  ${({ variant }) => getMaxWidth(variant)}
  ${({ variant }) => getMinWidth(variant)}
  ${({ variant }) => variant === "bordered"
    ? "overflow: hidden;"
    : `:focus-within {border: 0.094rem solid ${colors["color-blue-80"]};}
          border: 0.094rem solid #ffffff;
      `}
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  display: inline-block;
  border-radius: 0.5rem;
`;
export const Title = styled.span `
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.75rem;
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const Subtitle = styled.span `
  font-size: 0.875rem;
  padding-top: 0.5rem;
`;
export const IconContainer = styled.div `
  width: 2rem;
  height: 2rem;
`;
export const Content = styled.div `
  color: #121212;
  font-size: 0.875rem;
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
`;
function getWidth(variant) {
    switch (variant) {
        case "large":
            return css `
        width: 40.875rem;
      `;
        case "small":
            return css `
        width: 28rem;
      `;
        case "fullWidth":
            return css `
        width: 100%;
      `;
        default:
            return css `
        width: auto;
      `;
    }
}
function getMaxWidth(variant) {
    switch (variant) {
        case "large":
            return css `
        max-width: 56rem;
      `;
        case "small":
            return css `
        max-width: 25.125rem;
      `;
        case "fullWidth":
            return css `
        max-width: 100%;
      `;
        default:
            return css `
        max-width: auto;
      `;
    }
}
function getMinWidth(variant) {
    switch (variant) {
        case "small":
            return css `
        min-width: 25.125rem;
      `;
        case "bordered":
            return css `
        min-width: auto;
      `;
        default:
            return css `
        min-width: 25.875rem;
      `;
    }
}
function getBorderRadius(variant) {
    switch (variant) {
        case "bordered":
            return css `
        border-radius: 0;
      `;
        default:
            return css `
        border-radius: 0.5rem;
      `;
    }
}
function getPadding(variant, padding) {
    switch (variant) {
        case "bordered":
            return css `
        padding: 2.5rem;
      `;
        default:
            switch (padding) {
                case "wide":
                    return css `
            padding: 2rem 2.5rem 2.5rem;
          `;
                default:
                    return css `
            padding: 1rem 1rem 1.25rem;
          `;
            }
    }
}
//# sourceMappingURL=Card.styled.js.map